<template>
    <div class="kanban-settings-overlay">
        <div class="overlay-content">
            <h3>{{ $t("settings.title") }}</h3>
            <!-- Kanban Kolon Ayarları -->
            <h4>{{ $t("modules.kanbanSettings.column") }}</h4>
            <p>{{ $t("modules.kanbanSettings.selectField") }}</p>
            <a-select class="kanban-field-selector" v-model="localSettings.kanbanField" :placeholder="$t('settings.selectFieldPlaceholder')">
                <a-select-option v-for="field in dropdownFields" :key="field._id" :value="field._id">
                    {{ field.name }}
                </a-select-option>
            </a-select>

            <!-- Kanban Kart Ayarları -->
            <h4>{{ $t("modules.kanbanSettings.card") }}</h4>
            <p>{{ $t("modules.kanbanSettings.selectFields") }}</p>
            <div class="kanban-card-fields">
                <div v-for="field in fields" :key="field._id" class="field-checkbox">
                    <a-checkbox
                        :checked="localSettings.cardFields.indexOf(field._id) !== -1"
                        @change="toggleCardField(field._id)"
                    >
                        {{ field.name }}
                    </a-checkbox>
                </div>
            </div>

            <div class="footer">
                <a-button type="default" @click="$emit('close')">{{ $t('modules.kanbanSettings.cancel') }}</a-button>
                <a-button type="primary" @click="handleSave">{{ $t('modules.kanbanSettings.save') }}</a-button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "KanbanSettingsOverlay",
    props: {
        fields: {
            type: Array,
            default: function () {
                return [];
            },
        },
        kanbanSettings: {
            type: Object,
            default: function () {
                return {
                    kanbanField: null,
                    cardFields: [],
                };
            },
        },
    },
    data: function () {
        return {
            localSettings: {
                kanbanField: null,
                cardFields: [],
            },
        };
    },
    computed: {
        /**
         * Sadece dropdown + static olanları döndür.
         */
        dropdownFields: function () {
            var arr = [];
            for (var i = 0; i < this.fields.length; i++) {
                var f = this.fields[i];
                if (f.fieldType === "dropdown" && f.options && f.options.dropdown.mode === "static") {
                    arr.push(f);
                }
            }
            return arr;
        },
    },
    created: function () {
        // Mevcut ayarları localSettings'e kopyalar
        this.localSettings.kanbanField = this.kanbanSettings.kanbanField;
        this.localSettings.cardFields = this.kanbanSettings.cardFields.slice(); // Dizi kopyalama
    },
    methods: {
        toggleCardField: function (fieldId) {
            var idx = this.localSettings.cardFields.indexOf(fieldId);
            if (idx > -1) {
                this.localSettings.cardFields.splice(idx, 1);
            } else {
                this.localSettings.cardFields.push(fieldId);
            }
        },
        handleSave: function () {
            var updatedSettings = {
                kanbanField: this.localSettings.kanbanField,
                cardFields: this.localSettings.cardFields,
            };
            this.$emit("saveSettings", updatedSettings);
            this.$emit("close");
        },
    },
});
</script>

<style scoped lang="scss">
.kanban-settings-overlay {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    width: 300px;
    background: #fff;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.15);
    z-index: 9999;
    padding: 16px;

    .overlay-content {
        display: flex;
        flex-direction: column;
        height: 100%;

        .kanban-field-selector {
            width: 100%;
        }

        .field-checkbox {
            margin: 4px 0;
        }

        .footer {
            margin-top: auto;
            display: flex;
            justify-content: space-between;
            padding-top: 16px;
            border-top: 1px solid #e8e8e8;
        }
    }
    .kanban-card-fields {
        display: flex;
        flex-direction: column;
        gap: 8px;
        overflow-y: auto;
    }
}
</style>
